module.exports = __webpack_public_path__ + "img/logo.a9a02831.png";